<div class="flex flex-col gap-4 pb-4">
  <!-- TODO: if the export level is not full analytics, do not display it in analytics planned mode -->
  @if (isAnalyticsPlannedMode()) {
    <app-cta-analytics-details-planned-view
      [analyticsNode]="analyticsNode()"
      [execution]="execution()"
      [creatorId]="creatorId()"
      [kpiGoalsKpiCards]="searchFilteredKpiGoalsKpiCards()"
      [creatorBriefingMode]="creatorBriefingMode()"
    />
  } @else if (
    deliverableCardData().length > 0 ||
    (exportMode() && (!campaignExport()?.showDeliverableStatus || !campaignExport()?.showKpiStatus))
  ) {
    <div class="flex flex-col gap-6">
      <app-cta-analytics-details-deliverables-header
        [analyticsNode]="analyticsNode()"
        [ctaResult]="ctaResult()"
        [execution]="execution()"
        [adminMode]="adminMode()"
        [creatorBriefingMode]="creatorBriefingMode()"
        [exportMode]="exportMode()"
        [campaignExport]="campaignExport()"
        (ctaShowRequested)="ctaExecutionChange.emit($event)"
      />

      <div class="flex flex-col">
        <!-- Search disabled for now -->
        <!-- <div class="flex items-center ml-6 min-h-8">
          @if (showSearch()) {
            <mat-form-field class="custom-form deliverable-card-search">
              <input
                matInput
                [formControl]="searchControl"
                [placeholder]="'pages.campaignDetails.ctaAnalytics.details.searchPlaceholder' | translate"
                (blur)="onSearchBlur()"
                #searchInput
              />

              <div matPrefix>
                <app-icon src="/icons/search.svg" class="w-4 h-4" />
              </div>

              @if (searchControl.value) {
                <button mat-icon-button matSuffix (click)="clearSearch()" type="button">
                  <app-icon src="/icons/x-mark.svg" alt="Clear" class="w-4 h-4" />
                </button>
              }
            </mat-form-field>
          } @else {
            <button mat-icon-button class="mat-secondary-transparent-button-color" (click)="onSearchClick()">
              <app-icon src="/icons/search.svg" alt="Search" class="w-4 h-4" />
            </button>
          }
        </div> -->

        <div class="flex flex-col gap-3">
          @if (deliverablesTableRows().length > 0) {
            <div class="flex flex-col">
              <h3 class="text-base pl-6" [ngClass]="{ 'max-md:pl-0 max-md:mb-3': creatorBriefingMode() }">
                {{ 'shared.tile.deliverables' | translate }}
              </h3>

              @if (mobileBriefing()) {
                <!-- Mobile briefing sheet: rows instead of the 3-column table, reusing the table's cell templates. -->
                <div class="flex flex-col" data-testid="cta-analytics-details-deliverable-list">
                  @for (row of deliverablesTableRows(); track $index) {
                    <button
                      type="button"
                      class="flex items-center gap-3 min-h-11 px-4 py-2.5 rounded-3xl text-left text-sm"
                      data-testid="cta-analytics-details-deliverable-row"
                      [class.bg-shikenso-gray-base]="$even"
                      [disabled]="!canClickOnDeliverable()"
                      (click)="onRowClick(row)"
                    >
                      <div class="flex flex-col items-start gap-1 min-w-0 flex-1">
                        @if (canShowStatus()) {
                          <ng-container *ngTemplateOutlet="statusColumn; context: { row }" />
                        }

                        <ng-container *ngTemplateOutlet="deliverableColumn; context: { row }" />
                      </div>

                      <span class="shrink-0 font-bold">
                        <ng-container *ngTemplateOutlet="findingsColumn; context: { row }" />
                      </span>

                      @if (canClickOnDeliverable()) {
                        <app-icon class="shrink-0" src="icons/chevron-right.svg" [size]="16" />
                      }
                    </button>
                  }
                </div>
              } @else {
                <div class="cta-analytics-details-table">
                  <app-datatable
                    [rowData]="deliverablesTableRows()"
                    [columns]="deliverablesVisibleColumns()"
                    [configurationInput]="datatableConfig()"
                    [customColumnDef]="deliverablesCustomColumns()"
                    [total]="deliverablesTableRows().length"
                    [isInitialDataLoaded]="true"
                    [loadingData]="false"
                    (rowClick)="onRowClick($event.row)"
                  />
                </div>
              }
            </div>
          }

          <app-cta-analytics-details-kpi-goals-table
            [creatorBriefingMode]="creatorBriefingMode()"
            [execution]="execution()"
            [kpiGoalsKpiCards]="searchFilteredKpiGoalsKpiCards()"
          />

          @if (!creatorBriefingMode() && observationsTableRows().length > 0) {
            <div class="flex flex-col mt-3">
              <hr class="border-shikenso-purple-base-12 my-3 ml-6 mr-4" />

              <h3 class="text-xl font-bold pl-6">
                {{ 'pages.campaignDetails.ctaAnalytics.details.observations' | translate }}
              </h3>

              <div class="cta-analytics-details-table">
                <app-datatable
                  [rowData]="observationsTableRows()"
                  [columns]="observationsVisibleColumns()"
                  [configurationInput]="datatableConfig()"
                  [customColumnDef]="observationsCustomColumns()"
                  [total]="observationsTableRows().length"
                  [isInitialDataLoaded]="true"
                  [loadingData]="false"
                  (rowClick)="onRowClick($event.row)"
                />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

<ng-template #statusColumn let-row="row">
  @if (!canShowStatus()) {
    <span class="text-sm text-shikenso-purple-base-60">-</span>
  } @else if (row.isStatusLoading) {
    <ngx-skeleton-loader class="h-6" [theme]="{ width: '80px', height: '24px', 'border-radius': '100vw' }" />
  } @else if (row.isTracking) {
    <app-status-badge colorScheme="tracking" [status]="row.status" />
  } @else {
    <app-status-badge colorScheme="deliverable" [status]="row.status" />
  }
</ng-template>

<ng-template #deliverableColumn let-row="row">
  <div class="flex items-center gap-1">
    <!--
      Mobile sheet rows: an active tooltip sets `touch-action: none` on touch devices, which would stop swipes that
      start on the name from scrolling the list, so names wrap to 2 lines there instead of relying on the tooltip.
    -->
    <span
      matTooltip
      matTooltipPosition="left"
      class="line-clamp-1 text-ellipsis block max-w-[240px]"
      [ngClass]="{ 'max-md:line-clamp-2 max-md:max-w-none': mobileBriefing() }"
      [matTooltipTouchGestures]="mobileBriefing() ? 'off' : 'auto'"
      [appTextClampTooltip]="row.data.name"
      [defaultTooltip]="
        ('shared.deliverableTypes.' + row.data.type | translate) + ' ' + ('shared.deliverable' | translate)
      "
    >
      {{ row.data.name }}
    </span>

    @if (!row.data.sponsoredContentRelevant) {
      <app-icon
        src="/icons/eye-closed.svg"
        matTooltipPosition="right"
        [size]="16"
        [matTooltip]="'pages.campaignDetails.ctaAnalytics.details.excludedFromSponsoredContent' | translate"
      />
    }
  </div>
</ng-template>

<ng-template #trackingColumn let-row="row">
  <span
    matTooltip
    matTooltipPosition="left"
    class="line-clamp-1 text-ellipsis block max-w-[240px]"
    [appTextClampTooltip]="row.data.name"
    [defaultTooltip]="'shared.deliverableTypes.' + row.data.type | translate"
  >
    {{ row.data.name }}
  </span>
</ng-template>

<ng-template #findingsColumn let-row="row">
  @if (row.status === EMatchingType.planned) {
    <span>-</span>
  } @else {
    <span>{{ row.findings }}</span>
  }
</ng-template>
